export default "__VITE_ASSET__OijRFtoN__"